<template>
  <div :class="classes">
    <pt-page-title
      :title="pageTitle"
      :isSearch="true"
      @search="search"
      :searchKey="searchKey"
      @emptySearch="emptySearch"
    ></pt-page-title>
    <p :class="$style['title-color']">
      当前商城用户总数：
      <span :class="$style.num" v-if="AllMallUser">{{ AllMallUser }}人</span>
      <i class="el-icon-loading" v-else></i>
    </p>
    <pt-page-factor-filter
      :labels="filterLabels"
      v-model="params"
      isQueryRouter
      ref="filter"
      @Filter="Filter"
    >
      <template>
        <el-button type="primary" @click="Filter()">筛选</el-button>
        <template v-if="showExportButton">
          <el-button
            type="primary"
            @click="exportCustomer"
            :loading="exportLoading"
            >导出</el-button
          >
          <el-button type="primary" @click="exportHistoryCustomer"
            >导出历史</el-button
          >
        </template>
        <el-button type="text" @click="cleanParams">清除筛选条件</el-button>
      </template>
    </pt-page-factor-filter>
    <pt-customer-table
      ref="table"
      :paramsData="paramsData"
      :tableLabels="userTableLabels"
      :isFromRouter="isFromRouter"
    >
      <el-table-column label="操作" min-width="100" fixed="right">
        <template slot-scope="scope">
          <i
            class="iconfont icon-xiangqing"
            @click="cunstomerDetail(scope.row)"
          ></i>
          <!-- <i class="iconfont icon-bianji"></i>
                   <i class="iconfont icon-shanchu" @click="deleteCustomer(scope.row)"></i> -->
        </template>
      </el-table-column>
    </pt-customer-table>
  </div>
</template>

<script>
// 组件class前缀
import ptCustomerTable from './pt-customer-table/withData'
import { userTableLabels, geneUserTableLabels, adultUserTableLabels, onlineUserTableLabels, customerTableFilter } from './all-customer-option'
import { emptyObject } from '@/utils/lifebankUtils'
import { hasPermissions } from 'utils/permissions'
const prefixCls = 'pt-all-customer'
const PERM_MALL_USER_EXPORT = 'PERM_MALL_USER_EXPORT'
export default {
  name: 'pt-all-customer',
  computed: {
    classes () {
      return `${prefixCls}`
    },
    userTableLabels () {
      return this.routeName === 'customer-of-gene' ? geneUserTableLabels : (this.routeName === 'customer-of-adult-cells'
        ? adultUserTableLabels : (this.routeName === 'online-customer' ? onlineUserTableLabels : userTableLabels))
    },
    pageTitle () {
      return this.routeName === 'customer-of-gene' ? '基因检测用户' : (this.routeName === 'customer-of-adult-cells'
        ? '成人细胞存储用户' : (this.routeName === 'online-customer' ? '线上用户' : '全部用户'))
    },
    tableData () {
      return this.$refs.table.tableData
    },
    // 是否显示导出按钮（拥有导出权限）
    showExportButton () {
      return this.$auth.user() && this.$auth.user().permissions && hasPermissions(this.$auth.user().permissions, PERM_MALL_USER_EXPORT)
    }
  },
  props: {
    allCitys: {
      type: Array,
      default: function () {
        return []
      }
    },
    AllMallUser: {
      type: Number,
      default: function () {
        return 0
      }
    },
    sourceList: {
      type: Array,
      default: function () {
        return []
      }
    },
    exportLoading: {
      type: Boolean,
      default: false
    },
    branchCompanys: {
      type: Array
    }
  },
  components: {
    ptCustomerTable
  },
  data () {
    return {
      filterLabels: customerTableFilter,
      params: {},
      paramsData: {},
      routeName: this.$route.name,
      searchKey: null,
      isFromRouter: false
    }
  },
  watch: {
    allCitys (val) {
      this.getFilterLabelsOptions(val, 'city')
    },
    sourceList (val) {
      this.getFilterLabelsOptions(val, 'channel')
    },
    branchCompanys (val) {
      this.getFilterLabelsOptions(val, 'businessBranchId')
    }
  },
  methods: {
    exportCustomer () {
      if (this.tableData && this.tableData.length) {
        this.$confirm('导出操作需要花费一定时间，完成导出后我们会将数据保存在“导出历史”中，您稍后下载即可。', '导出提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning' }).then(_ => {
          for (var key in this.params) {
            if (!this.params[key]) {
              this.$delete(this.params, key)
            }
            if (key === 'registryTime' || key === 'age') {
              this.$delete(this.params[key], 'index')
              this.params = { ...this.params, ...this.params[key] }
              this.$delete(this.params, key)
            }
          }
          let paramsData = { ...this.params, searchKey: this.searchKey }
          // this.params.searchKey = this.searchKey ? this.searchKey : null
          this.$emit('exportAllCustomer', paramsData)
        })
      } else {
        this.$alert('该列表暂无可导出记录', '导出提示', {
          confirmButtonText: '确定',
          type: 'warning',
          callback: action => {
          }
        })
      }
    },
    exportHistoryCustomer () {
      this.$router.push('/export-history/customer-list?name=mall_user_export')
    },
    // 给筛选选项赋值
    getFilterLabelsOptions (val, name) {
      this.filterLabels.forEach(item => {
        if (item.value === name) {
          item.options = val
        }
      })
    },
    initTimeSlot (val, name) {
      let date = new Date().getTime()
      this.$route.query.endDate = date
      this.$route.query.startDate = date - 30 * 24 * 3600 * 1000
    },
    search (val) {
      this.searchKey = val
      emptyObject(this.paramsData)
      emptyObject(this.params)
      this.$set(this.paramsData, 'searchKey', val)
      this.isFromRouter = false
    //   this.paramsData.searchKey = val
    },
    emptySearch () {
      this.$delete(this.paramsData, 'searchKey')
    },
    Filter (isFromRouter) {
      if (!isFromRouter) {
        this.searchKey = null
        if (this.params.searchKey) {
          this.$delete(this.params, 'searchKey')
        }
      }
      this.isFromRouter = isFromRouter
      if (this.params.age) {
        this.params = { ...this.params, ...this.params.age }
        this.$delete(this.params, 'age')
      }
      if (this.params.registryTime) {
        this.params = { ...this.params, ...this.params.registryTime }
        this.$delete(this.params, 'registryTime')
        this.$delete(this.params, 'index')
        // this.$delete(this.paramsData, 'index')
      }
      this.paramsData = { ...this.params }
      if (this.paramsData.bindCps) {
        this.paramsData.bindCps = this.paramsData.bindCps === 'true'
      }
      if (this.paramsData.qjkProductBuy) {
        this.paramsData.qjkProductBuy = this.paramsData.qjkProductBuy === 'true'
      }
      for (var key in this.paramsData) {
        if (!this.paramsData[key] && this.paramsData[key] !== false) {
          this.$delete(this.paramsData, key)
        }
      }
      if (!isFromRouter) {
        this.$refs.filter.getAddRouter(this.params)
      }
    },
    cunstomerDetail (row) {
      this.$router.push('/all-customer/customer-detail/' + row.id + '?state=basic-message')
    },
    deleteCustomer (row) {
      this.$confirm('您确定删除该用户吗', '删除用户', {
        confirmButtonText: '确定',
        cancelButtonText: '取消'
      }).then(_ => {
      })
    },
    cleanParams () {
      emptyObject(this.paramsData)
      emptyObject(this.params)
      this.Filter()
    }
  },
  created () {
    this.initTimeSlot()
  }
}
</script>

<style module lang="less">
/* 已启用css module， template中请使用$style.className添加class */
/* 务必遵循css BEM原则 */

.title-color{
  color:#909399;
  position: absolute;
  top: 0;
  left: 1.2rem;
}
.num{
  color:#edbe81;
}
</style>
<style lang="less">
.pt-all-customer{
  position: relative;
    i{
        margin-right:10px;
    }
}
</style>
